import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';

import {DiscountBanner} from './shared';

const Banner = styled(DiscountBanner)``;

interface Props {
  orderTypeOrigin?: string;
  discount?: string | number;
  className?: string;
}

const TerminalDiscountMessage = ({orderTypeOrigin, discount, className}: Props) => {
  const {t} = getLocalizationService();

  if (orderTypeOrigin !== 'terminal' || !(Number(discount) > 0)) {
    return null;
  }

  return (
    <Banner className={className}>
      {t('in_this_order_you_recived_xxxx_discount', {discount})}
    </Banner>
  );
};

export default TerminalDiscountMessage;
